import { PushNotificationServiceInterface } from 'domain/services';
import { PushNotificationUseCaseInterface } from 'domain/usecases';

interface UseCasesInjection {
  pushNotification: PushNotificationUseCaseInterface;
}

export class PushNotificationService
  implements PushNotificationServiceInterface
{
  private readonly _pushNotification: PushNotificationUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._pushNotification = usecases.pushNotification;
  }

  pushNotification(
    params: PushNotificationUseCaseInterface.Params,
  ): Promise<PushNotificationUseCaseInterface.Result> {
    return this._pushNotification.execute(params);
  }
}
